var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":_vm.color,"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"text-h4"},[_vm._v(_vm._s(_vm.contrat.type.acronyme))]),_c('p',{staticClass:"text-body-2"},[_vm._v(_vm._s(_vm.dates))]),_c('div',{staticClass:"text-body-1"},[_vm._v(_vm._s(_vm.sousTitre))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }